<div [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}" class="login-container">
  <form (ngSubmit)="onSubmit()" *ngIf="!syncMode && !syncError" [formGroup]="loginForm" class="login-form">
    <img alt="music-work-logo" src="/assets/login_logo.svg">
    <fieldset class="fieldset-playercode">
      <legend translate>login.label</legend>
      <div>
        <label for="login-input">Player code</label>
        <input [disabled]="bidPending"
               formControlName="playerBid"
               id="login-input"
               name="email" required
               type="text"
        />
      </div>
      <span *ngIf="bidPending" class="gear-loader-container">
        <span class="gear-loader"></span>
      </span>
      <div class="bid-error-message">
        <span *ngIf="bidError"> {{bidError}} </span>
      </div>
    </fieldset>
    <button class="rounded-button red" id="login-submit" translate type="submit">login.label</button>
    <div class="version">v{{currentApplicationVersion}}</div>
  </form>

  <div *ngIf="syncError" class="error-display">
    <div class="text">
      <span [ngStyle]="httpError ? {'font-weight': 'bolder', 'font-size': '22px'} : {} ">{{syncError}}</span>
      <span *ngIf="httpError">{{httpError}}</span>
      <br>
      <span class="support-text center-text ">
        <a href="mailto:support@music-work.com"> support@music-work.com</a>
        <br>
        <a href="tel:+33 (0)1 76 46 05 42"> +33 (0)1 76 46 05 42</a>
      </span>
    </div>
  </div>

  <div *ngIf="syncMode">
    <mwo-progress-dialog
      [current]="currentValue"
      [message]="syncMessage"
      [total]="maxValue"
    ></mwo-progress-dialog>
  </div>

</div>
